import React from "react";
import { Options, UpdateOptions, useToasts as useToastsReact } from "react-toast-notifications";
import { CustomToastOptions } from "../../components/Toast/Toast.types.js";

export const useToasts = () => {
    const hook = useToastsReact();
    return {
        ...hook,
        addToast: (content: React.ReactNode, options?: CustomToastOptions & Options, callback?: (id: string) => void) => {
            hook.addToast(content, options, callback);
        },
        updateToast: (id: string, options?: CustomToastOptions & UpdateOptions, callback?: (id: string) => void) => {
            hook.updateToast(id, options, callback);
        },
    };
};
